import * as React from "react";
import { cn } from "@/lib/utils";

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number;
  max?: number;
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value = 0, max = 100, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full bg-secondary dark:bg-secondary-dark",
        className,
      )}
      {...props}
    >
      <div
        className="h-full w-full flex-1 bg-primary dark:bg-primary-dark transition-all duration-300"
        style={{ transform: `translateX(-${100 - (value / max) * 100}%)` }}
      />
    </div>
  ),
);
Progress.displayName = "Progress";

export { Progress };
